import { UIElements } from '@ansvar-sakerhet/ui';

export const S = { ...UIElements };
